// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import React from "react";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 PRO React examples
import DefaultNavbar from "custom/Navbars/DefaultNavbar";
import DefaultFooter from "custom/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Contact card
import SimpleContactCard from "custom/Cards/ContactCards/SimpleContactCard";

function ContactUsPage() {
  return (
    <>
      <MKBox bgColor="linear-gradient(195deg, #42424a, #191919);" py={3}>
        <DefaultNavbar
          routes={routes}
          action={{
            type: "external",
            route: "/support/contact-us",
            label: "Comienza Ahora",
            color: "white",
          }}
          transparent
          relative
          light
        />
      </MKBox>
      <MKBox bgColor="white">
        <MKBox bgColor="white" component="section" minWidth="100vw" minHeight="100vh">
          <Container>
            <Grid container justifyContent="center">
              <Grid item xs={12}>
                <MKBox
                  position="relative"
                  borderRadius="xl"
                  py={3}
                  px={3}
                  sx={{ overflow: "hidden" }}
                  mt="10vh"
                >
                  <Container>
                    <Grid container item xs={12} flexDirection="column" justifyContent="center" alignContent="center">
                      <SimpleContactCard
                        color="primary"
                        title="Ponte en contacto con nosotros"
                        description="Nos pondremos en contacto contigo lo antes posible."
                      />
                    </Grid>
                  </Container>
                </MKBox>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <MKBox mt={10} pb={6}>
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={5} ml="auto" sx={{ textAlign: { xs: "center", lg: "left" } }}>
                <MKTypography variant="h4" fontWeight="bold" mb={0.5}>
                  ¡Conéctate con Nosotros!
                </MKTypography>
                <MKTypography variant="body1" color="text">
                  Más que un negocio, somos una comunidad.
                </MKTypography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={7}
                my={{ xs: 5, lg: "auto" }}
                mr={{ xs: 0, lg: "auto" }}
                sx={{ textAlign: { xs: "center", lg: "right" } }}
              >
                <MKSocialButton
                  component="a"
                  href="https://twitter.com/@PWNCAT_OFFICIAL"
                  target="_blank"
                  color="twitter"
                  sx={{ m: 1 }}
                >
                  <i className="fab fa-twitter" />
                  &nbsp;Tweet
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://github.com/offensive-security-pwncat"
                  target="_blank"
                  color="github"
                  sx={{ m: 1 }}
                >
                  <i className="fab fa-github" />
                  &nbsp;Participa
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.linkedin.com/company/96064718"
                  target="_blank"
                  color="linkedin"
                  sx={{ m: 1 }}
                >
                  <i className="fab fa-linkedin" />
                  &nbsp;Descubre
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.youtube.com/channel/UCzobc3PZEQSsEMF7IFCKryA"
                  target="_blank"
                  color="youtube"
                  sx={{ m: 1 }}
                >
                  <i className="fab fa-youtube" />
                  &nbsp;Sigue
                </MKSocialButton>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </MKBox>
    </>
  );
}

export default ContactUsPage;